import React from "react";
import { MAP_HEIGHT, MAP_WIDTH, NATION_PATH, STATE_LINES_PATH } from "./data/usMap";

// The US with its state lines, and dots on it. viewBox picks the part shown:
// the whole country for a question, a region for the answer.
//
// Dots and labels are sized in screen pixels, not map units, so they stay the
// same size whether the map shows the country or one corner of it. The map is
// drawn about 360px wide on a phone, which is what SCREEN_WIDTH converts
// against.
const SCREEN_WIDTH = 360;

const DOT = {
  target: "var(--color-danger)",
  right: "var(--color-success)",
  wrong: "var(--color-danger)",
  other: "var(--color-text-faint)",
};

function UsMap({ viewBox = [0, 0, MAP_WIDTH, MAP_HEIGHT], dots = [], label }) {
  const k = viewBox[2] / SCREEN_WIDTH;
  const right = viewBox[0] + viewBox[2];
  return (
    <svg
      viewBox={viewBox.join(" ")}
      role="img"
      aria-label={label}
      style={{ width: "100%", display: "block", borderRadius: 12, backgroundColor: "var(--color-bg-subtle)", aspectRatio: `${MAP_WIDTH} / ${MAP_HEIGHT}` }}
    >
      <path d={NATION_PATH} fill="var(--color-bg-card)" stroke="var(--color-text-faint)" strokeWidth={1 * k} strokeLinejoin="round" />
      <path d={STATE_LINES_PATH} fill="none" stroke="var(--color-text-faint)" strokeWidth={0.5 * k} strokeLinejoin="round" />
      {dots.map((d) => {
        // A label near the right edge goes on the left of its dot.
        const flip = d.x + 90 * k > right;
        return (
          <g key={d.key}>
            {d.kind === "target" && (
              <circle cx={d.x} cy={d.y} r={13 * k} fill="none" stroke={DOT.target} strokeWidth={2.5 * k} opacity={0.4} />
            )}
            <circle cx={d.x} cy={d.y} r={(d.kind === "target" ? 6 : 7) * k} fill={DOT[d.kind]} stroke="#fff" strokeWidth={2 * k} />
            {d.label && (
              <text
                x={d.x + (flip ? -11 : 11) * k}
                y={d.y + 4 * k}
                textAnchor={flip ? "end" : "start"}
                style={{ fontSize: 12 * k, fontWeight: 800, fill: "var(--color-text-strong)", paintOrder: "stroke", stroke: "var(--color-bg-card)", strokeWidth: 3.5 * k }}
              >
                {d.label}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}

export default UsMap;
